import { render, staticRenderFns } from "./ApfReferralChannelSelector.vue?vue&type=template&id=4034f2fd"
import script from "./ApfReferralChannelSelector.vue?vue&type=script&lang=js"
export * from "./ApfReferralChannelSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports